import { indexedDBLocalPersistence } from 'firebase/auth'
import {
  readPersistedAuthUidFromIdb,
  readPersistedAuthUidFromIdbSafe,
  type AuthIdbPersistenceReader,
  type PersistedAuthUidReadResult,
} from './firebaseAuthIdbShared.ts'

type InternalPersistence = AuthIdbPersistenceReader

type PersistenceProvider = InternalPersistence | (new () => InternalPersistence)

function getIndexedDbPersistence(): InternalPersistence {
  const provider = indexedDBLocalPersistence as unknown as PersistenceProvider
  return typeof provider === 'function' ? new provider() : provider
}

/** Reads persisted Firebase Auth uid from shared IDB (main thread). Throws on IDB error. */
export async function readMainPersistedAuthUid(appName = '[DEFAULT]'): Promise<string | null> {
  const persistence = getIndexedDbPersistence()
  return readPersistedAuthUidFromIdb(persistence, appName)
}

/** Fail-open read for preflight: never throws. */
export async function readMainPersistedAuthUidSafe(
  appName = '[DEFAULT]',
): Promise<PersistedAuthUidReadResult> {
  const persistence = getIndexedDbPersistence()
  return readPersistedAuthUidFromIdbSafe(persistence, appName)
}
